import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { GET_ALL_FLASHCARDS } from '../queries/flashcards';

export const useFetchAllFlashcards = () => {
  const { data, loading, error } = useQuery(GET_ALL_FLASHCARDS);

  return {
    flashcards: data?.flashcards || [],
    loading,
    error,
  };
};

/**
 * Returns a `submit(flashcardId, rating)` function that records an FSRS review
 * for the given flashcard. The server runs the spaced-repetition scheduler and
 * persists the new memory state; the card resurfaces only when it next falls due.
 *
 * `rating` follows the FSRS scale: 1 Again, 2 Hard, 3 Good, 4 Easy. No-ops on a
 * falsy id or rating. This is a Django endpoint (FSRS is server-side compute), not
 * a DDN mutation.
 */
export const useSubmitFlashcardReview = () => useCallback((flashcardId, rating) => {
  if (!flashcardId || !rating) {
    return undefined;
  }
  const url = `${getConfig().LMS_BASE_URL}/blendxai/flashcards/review/`;
  return getAuthenticatedHttpClient().post(url, {
    flashcard_id: flashcardId,
    rating,
  });
}, []);
